import Newtechnicianform from './new_technician_form.vue'
import TechnicianDetail from './technician-detail.vue'
import TechniciansDetailTablePanel from './technicians-detail-table-panel.vue'
export default{
    Newtechnicianform,
    'technician-detail': TechnicianDetail,
    'technicians-detail-table-panel': TechniciansDetailTablePanel
}